// FAQ data — shared by FaqsPage and support resources
export const faqData = [
  {
    question: "What is Rithmo?",
    answer: "Rithmo is an AI-powered meeting governance platform that helps teams run more productive, equitable, and focused meetings by providing real-time moderation, agenda enforcement, and analytics."
  },
  {
    question: "How does Rithmo work?",
    answer: "Rithmo integrates with video conferencing platforms like Zoom to monitor meetings in real-time. It uses AI to track participation, enforce agendas, prevent interruptions, and provide live analytics to meeting facilitators."
  },
  {
    question: "What platforms does Rithmo support?",
    answer: "Currently, Rithmo primarily supports Zoom meetings. We're working on expanding support to other video conferencing platforms in the future."
  },
  {
    question: "How do I get started with Rithmo?",
    answer: "To get started, create an account on our platform, connect your Zoom account, and schedule or join a meeting. Rithmo will automatically join as a participant and begin moderating."
  },
  {
    question: "Is Rithmo available for individual users?",
    answer: "Rithmo is designed for teams and organizations. While individuals can create accounts, the full benefits are realized when used across team meetings."
  },
  {
    question: "Can Rithmo join any Zoom meeting?",
    answer: "Rithmo can join meetings where the organizer has connected their Zoom account to Rithmo. For public meetings or meetings you don't organize, you may need to coordinate with the meeting host."
  },
  {
    question: "What happens if Rithmo loses connection during a meeting?",
    answer: "If Rithmo loses connection, it will automatically attempt to reconnect. Meeting analytics up to that point are saved, and the system will resume monitoring once reconnected."
  },
  {
    question: "Does Rithmo record meetings?",
    answer: "Rithmo does not record meeting video or audio. It only processes real-time audio for moderation purposes and generates analytics based on participation patterns."
  },
  {
    question: "How does Rithmo ensure privacy?",
    answer: "Rithmo processes audio in real-time for moderation but does not store raw audio data. All processing happens securely in our infrastructure with enterprise-grade encryption."
  },
  {
    question: "Can I customize Rithmo's behavior?",
    answer: "Yes, Rithmo offers extensive customization options including interruption thresholds, agenda enforcement strictness, and participation equity targets that can be adjusted per meeting or organization-wide."
  },
  {
    question: "What analytics does Rithmo provide?",
    answer: "Rithmo provides comprehensive meeting analytics including talk time distribution, interruption frequency, agenda adherence, decision velocity, and productivity scores."
  },
  {
    question: "How does Rithmo help with meeting equity?",
    answer: "Rithmo tracks participation patterns and can highlight when certain participants are dominating discussions or being interrupted frequently, helping facilitators ensure more equitable participation."
  },
  {
    question: "Can Rithmo automatically mute participants?",
    answer: "Rithmo can suggest muting for excessive interruptions but requires facilitator approval for any automatic muting actions to ensure appropriate human oversight."
  },
  {
    question: "What languages does Rithmo support?",
    answer: "Rithmo currently supports English language meetings. We're working on expanding language support based on user demand."
  },
  {
    question: "Is Rithmo HIPAA compliant?",
    answer: "Rithmo is designed with privacy and security in mind, but HIPAA compliance depends on your specific use case and data handling practices. Please consult with your compliance team."
  },
  {
    question: "How much does Rithmo cost?",
    answer: "Rithmo is currently in development and not yet available for purchase. We'll announce pricing when we launch our beta program."
  },
  {
    question: "Can I try Rithmo before committing?",
    answer: "We're currently in private beta. Sign up for our waitlist to be notified when beta access becomes available."
  },
  {
    question: "What are the system requirements for Rithmo?",
    answer: "Rithmo requires a Zoom account and a modern web browser. No special hardware is needed beyond what's required for Zoom meetings."
  },
  {
    question: "How do I connect my Zoom account to Rithmo?",
    answer: "In your Rithmo dashboard, go to Settings > Integrations and click 'Connect Zoom'. You'll be redirected to Zoom's OAuth flow to grant the necessary permissions."
  },
  {
    question: "What Zoom permissions does Rithmo need?",
    answer: "Rithmo requires permissions to join meetings, access participant information, and moderate audio (muting/unmuting) when authorized by the meeting host."
  },
  {
    question: "Can Rithmo work with Zoom's free tier?",
    answer: "Yes, Rithmo works with all Zoom plans including the free tier, though some advanced features may require paid Zoom accounts."
  },
  {
    question: "How many meetings can I have with Rithmo?",
    answer: "There are no limits on the number of meetings you can moderate with Rithmo, though usage may be subject to fair use policies during beta."
  },
  {
    question: "What happens to my data if I delete my account?",
    answer: "When you delete your account, all your personal data and meeting analytics are permanently removed from our systems in accordance with our data retention policies."
  },
  {
    question: "Can I export my meeting data?",
    answer: "Yes, you can export your meeting analytics and reports from the Rithmo dashboard. Data export functionality is available in your account settings."
  },
  {
    question: "How does Rithmo handle time zones?",
    answer: "Rithmo automatically detects and handles time zones based on your account settings and Zoom account configuration."
  },
  {
    question: "Can Rithmo integrate with my calendar?",
    answer: "Rithmo integrates with Google Calendar and Microsoft Outlook to automatically detect upcoming meetings and offer to join them."
  },
  {
    question: "What if I forget my password?",
    answer: "Use the 'Forgot Password' link on the login page. You'll receive an email with instructions to reset your password."
  },
  {
    question: "How do I change my account email?",
    answer: "Go to Settings > Profile in your dashboard to update your email address. You'll need to verify the new email."
  },
  {
    question: "Can multiple people from my organization use Rithmo?",
    answer: "Yes, Rithmo supports organizational accounts where multiple team members can use the platform with shared settings and analytics."
  },
  {
    question: "How do I invite team members to Rithmo?",
    answer: "Organization admins can invite team members through the Team Management section in the dashboard."
  },
  {
    question: "What roles are available in Rithmo organizations?",
    answer: "Rithmo has three roles: Owner (full access), Admin (manage team and settings), and Member (use the platform)."
  },
  {
    question: "Can I see analytics across my entire organization?",
    answer: "Organization owners and admins can view aggregated analytics across all team meetings to identify organization-wide patterns and improvements."
  },
  {
    question: "How does Rithmo help with remote teams?",
    answer: "Rithmo is specifically designed for remote and hybrid teams, providing the structure and moderation that in-person meetings often have naturally."
  },
  {
    question: "What makes Rithmo different from other meeting tools?",
    answer: "Unlike basic meeting tools, Rithmo provides AI-powered governance, real-time moderation, and comprehensive analytics to improve meeting quality and equity."
  },
  {
    question: "Can Rithmo help with meeting agendas?",
    answer: "Yes, Rithmo can help create, track, and enforce meeting agendas, ensuring discussions stay on topic and time is used effectively."
  },
  {
    question: "How does Rithmo detect interruptions?",
    answer: "Rithmo uses advanced audio processing and AI to detect when participants interrupt each other, tracking patterns to promote more orderly discussions."
  },
  {
    question: "Can Rithmo suggest when to end a meeting?",
    answer: "Rithmo can provide recommendations when meetings are running over time or when all agenda items have been completed."
  },
  {
    question: "What is talk equity in Rithmo?",
    answer: "Talk equity measures how evenly speaking time is distributed among participants, helping identify and address participation imbalances."
  },
  {
    question: "How does Rithmo calculate productivity scores?",
    answer: "Productivity scores are based on agenda adherence, decision velocity, action item completion, and time management effectiveness."
  },
  {
    question: "Can I set goals for my meetings?",
    answer: "Yes, you can set targets for talk equity, agenda adherence, and other metrics to guide meeting facilitation."
  },
  {
    question: "Does Rithmo work with recurring meetings?",
    answer: "Yes, Rithmo fully supports recurring meetings and can maintain consistent governance across meeting series."
  },
  {
    question: "How do I schedule a meeting with Rithmo?",
    answer: "You can schedule meetings directly through Rithmo's interface or connect your calendar to automatically detect and join scheduled meetings."
  },
  {
    question: "Can Rithmo send meeting reminders?",
    answer: "Yes, Rithmo can send automated reminders to participants before scheduled meetings."
  },
  {
    question: "What happens if the meeting host leaves?",
    answer: "Rithmo continues monitoring the meeting as long as at least one participant remains. Moderation capabilities may be limited without a host present."
  },
  {
    question: "Can Rithmo work in breakout rooms?",
    answer: "Currently, Rithmo monitors main meeting rooms. Breakout room support is planned for future updates."
  },
  {
    question: "How does Rithmo handle large meetings?",
    answer: "Rithmo is optimized for meetings of various sizes, from small team meetings to large all-hands gatherings with hundreds of participants."
  },
  {
    question: "Can I customize Rithmo's AI sensitivity?",
    answer: "Yes, you can adjust sensitivity settings for interruption detection, agenda enforcement, and other AI features."
  },
  {
    question: "What training data does Rithmo use?",
    answer: "Rithmo's AI models are trained on general meeting patterns and best practices, not on specific user data or conversations."
  },
  {
    question: "How often is Rithmo updated?",
    answer: "Rithmo receives regular updates with new features, improvements, and AI model enhancements based on user feedback and research."
  },
  {
    question: "Can I provide feedback on Rithmo?",
    answer: "Absolutely! We welcome feedback through the support form, in-app feedback tools, and our community forums."
  },
  {
    question: "Is there a mobile app for Rithmo?",
    answer: "Currently, Rithmo is web-based. Mobile support is planned for future releases."
  },
  {
    question: "Can Rithmo integrate with project management tools?",
    answer: "Rithmo integrates with popular project management platforms to sync action items and meeting outcomes."
  },
  {
    question: "How does Rithmo handle different meeting types?",
    answer: "Rithmo adapts its behavior based on meeting type (standup, brainstorming, decision-making, etc.) with appropriate governance settings."
  },
  {
    question: "Can I create meeting templates?",
    answer: "Yes, you can save meeting configurations as templates for consistent governance across similar meeting types."
  },
  {
    question: "What is the learning engine in Rithmo?",
    answer: "Rithmo's learning engine analyzes meeting patterns across your organization to provide personalized recommendations for improvement."
  },
  {
    question: "How does Rithmo improve over time?",
    answer: "Rithmo continuously learns from successful meeting patterns and user feedback to provide better recommendations and automation."
  },
  {
    question: "Can Rithmo detect meeting fatigue?",
    answer: "Rithmo can identify patterns that may indicate meeting fatigue, such as declining engagement or participation over time."
  },
  {
    question: "What reports does Rithmo generate?",
    answer: "Rithmo generates detailed reports on meeting effectiveness, participant engagement, decision outcomes, and trends over time."
  },
  {
    question: "Can I share Rithmo reports with my team?",
    answer: "Yes, you can share meeting reports and analytics with team members or export them for presentations."
  },
  {
    question: "How does Rithmo handle confidential meetings?",
    answer: "Rithmo treats all meetings with the same level of security and privacy. No meeting content is stored or shared without explicit permission."
  },
  {
    question: "Can Rithmo work offline?",
    answer: "Rithmo requires an internet connection to function, as it needs to communicate with video conferencing platforms and our servers."
  },
  {
    question: "What browsers does Rithmo support?",
    answer: "Rithmo works on all modern browsers including Chrome, Firefox, Safari, and Edge."
  },
  {
    question: "Is there a limit to meeting duration?",
    answer: "There are no artificial limits on meeting duration, though very long meetings may have practical limitations based on platform constraints."
  },
  {
    question: "How does Rithmo handle multiple speakers at once?",
    answer: "Rithmo uses advanced audio processing to handle overlapping speech and can provide insights into conversation dynamics."
  },
  {
    question: "Can Rithmo transcribe meetings?",
    answer: "Rithmo focuses on real-time moderation rather than transcription. Integration with transcription services may be available in the future."
  },
  {
    question: "What is the difference between Rithmo and a human moderator?",
    answer: "Rithmo provides consistent, data-driven moderation that never tires, while human moderators bring contextual understanding and emotional intelligence."
  },
  {
    question: "Can Rithmo facilitate icebreakers?",
    answer: "Rithmo can suggest icebreaker activities and time them appropriately within meeting agendas."
  },
  {
    question: "How does Rithmo handle technical difficulties?",
    answer: "Rithmo is designed to be resilient to technical issues and will continue monitoring as long as the underlying meeting platform functions."
  },
  {
    question: "Can I pause Rithmo during a meeting?",
    answer: "Yes, facilitators can pause Rithmo's active moderation while maintaining analytics collection."
  },
  {
    question: "What happens to analytics if I pause Rithmo?",
    answer: "Analytics collection continues even when active moderation is paused, ensuring complete meeting data."
  },
  {
    question: "Can Rithmo suggest agenda items?",
    answer: "Based on meeting history and organizational patterns, Rithmo can suggest agenda items for recurring meetings."
  },
  {
    question: "How does Rithmo measure decision velocity?",
    answer: "Decision velocity measures how quickly decisions are made relative to discussion time, indicating meeting efficiency."
  },
  {
    question: "What is agenda adherence in Rithmo?",
    answer: "Agenda adherence measures how well the actual meeting discussion follows the planned agenda structure."
  },
  {
    question: "Can Rithmo detect when discussions go off-topic?",
    answer: "Rithmo can identify when conversations deviate from agenda items and suggest refocusing the discussion."
  },
  {
    question: "How does Rithmo help with action items?",
    answer: "Rithmo can track action items mentioned during meetings and monitor their completion status."
  },
  {
    question: "Can Rithmo integrate with task management tools?",
    answer: "Rithmo integrates with popular task management platforms to automatically create and track action items."
  },
  {
    question: "What is the productivity index in Rithmo?",
    answer: "The productivity index combines multiple metrics including decision velocity, action item completion, and time management into a single score."
  },
  {
    question: "How does Rithmo calculate time saved?",
    answer: "Rithmo calculates time saved by measuring early meeting endings, reduced interruptions, and more efficient discussions."
  },
  {
    question: "Can I see trends over time?",
    answer: "Yes, Rithmo provides trend analysis showing how meeting effectiveness improves over weeks and months."
  },
  {
    question: "What is the focus time ratio?",
    answer: "Focus time ratio measures the percentage of meeting time spent on productive, on-topic discussion versus tangents or interruptions."
  },
  {
    question: "How does Rithmo help with meeting preparation?",
    answer: "Rithmo can suggest agenda items, estimate meeting duration, and provide historical data to help prepare for upcoming meetings."
  },
  {
    question: "Can Rithmo predict meeting outcomes?",
    answer: "Based on historical data, Rithmo can provide predictions about likely meeting outcomes and suggest optimizations."
  },
  {
    question: "What is the time discipline score?",
    answer: "Time discipline score measures how well meetings start and end on time, and how effectively time is allocated to agenda items."
  },
  {
    question: "How does Rithmo handle different cultures?",
    answer: "Rithmo's algorithms are designed to be culturally aware and can be calibrated for different communication styles and norms."
  },
  {
    question: "Can Rithmo work with external facilitators?",
    answer: "Yes, Rithmo can enhance external facilitators by providing data-driven insights and automating routine moderation tasks."
  },
  {
    question: "What training is required to use Rithmo?",
    answer: "Rithmo is designed to be intuitive, but we provide onboarding guides and best practices for optimal use."
  },
  {
    question: "Is there a free trial for Rithmo?",
    answer: "We're currently in beta development. Free trials will be available when we launch our public beta program."
  },
  {
    question: "How do I contact Rithmo support?",
    answer: "You can contact support through this form, or reach out to our team directly for urgent issues."
  },
  {
    question: "What if I need help during a meeting?",
    answer: "Rithmo provides real-time guidance during meetings, and our support team is available for complex issues."
  },
  {
    question: "Can I request new features for Rithmo?",
    answer: "Absolutely! We love hearing feature requests from users. Use the support form to suggest new capabilities."
  },
  {
    question: "How often do you release new features?",
    answer: "We release updates regularly, typically every 2-4 weeks, based on user feedback and our development roadmap."
  },
  {
    question: "Is Rithmo available in other countries?",
    answer: "Rithmo is currently available globally where Zoom is supported. We're working on localized features for different regions."
  },
  {
    question: "What data centers does Rithmo use?",
    answer: "Rithmo uses secure, SOC 2 compliant data centers with global distribution for optimal performance."
  },
  {
    question: "How does Rithmo ensure data security?",
    answer: "Rithmo employs enterprise-grade encryption, regular security audits, and follows industry best practices for data protection."
  },
  {
    question: "Can I use Rithmo for client meetings?",
    answer: "Yes, Rithmo can be used for client meetings, though you should inform clients about the moderation technology being used."
  },
  {
    question: "What if my client doesn't want AI moderation?",
    answer: "You can disable active moderation features while still collecting analytics for internal review."
  },
  {
    question: "Can Rithmo work with webinar formats?",
    answer: "Rithmo is optimized for interactive meetings but can work with webinar formats with appropriate configuration."
  },
  {
    question: "How does Rithmo handle waiting rooms?",
    answer: "Rithmo respects Zoom's waiting room settings and will join meetings according to the host's permissions."
  },
  {
    question: "Can I customize Rithmo's interface?",
    answer: "The Rithmo dashboard offers customization options for layouts, themes, and notification preferences."
  },
  {
    question: "What notifications does Rithmo send?",
    answer: "Rithmo can send meeting reminders, summary reports, and alerts for governance events during meetings."
  },
  {
    question: "Can I integrate Rithmo with Slack or Microsoft Teams?",
    answer: "Rithmo integrates with communication platforms for notifications and can pull meeting data from connected calendars."
  },
  {
    question: "How does Rithmo handle meeting recordings?",
    answer: "Rithmo works alongside Zoom's recording features but does not store or process recorded content itself."
  },
  {
    question: "Can Rithmo generate meeting summaries?",
    answer: "Yes, Rithmo automatically generates comprehensive meeting summaries including key decisions, action items, and analytics."
  },
  {
    question: "What format are Rithmo reports in?",
    answer: "Reports are available in web format, PDF, and various data formats for integration with other tools."
  },
  {
    question: "Can I brand Rithmo reports?",
    answer: "Organization admins can customize report branding with company logos and colors."
  },
  {
    question: "How long are meeting analytics stored?",
    answer: "Meeting analytics are stored according to your organization's data retention policies, with standard retention of 7 years."
  },
  {
    question: "Can I delete meeting data?",
    answer: "Yes, you can delete individual meeting data or set automated retention policies for your organization."
  },
  {
    question: "What is the Rithmo API?",
    answer: "Rithmo provides a REST API for integrating meeting data and automation into other business tools and workflows."
  },
  {
    question: "Can I build custom integrations with Rithmo?",
    answer: "Yes, our API allows for custom integrations. Enterprise customers have access to additional integration tools."
  },
  {
    question: "Is there a Rithmo partner program?",
    answer: "We're developing a partner program for consultants and integrators who want to offer Rithmo services to their clients."
  },
  {
    question: "How does Rithmo compare to traditional meeting facilitators?",
    answer: "Rithmo augments human facilitators with data-driven insights and automation, making facilitation more effective and scalable."
  },
  {
    question: "Can Rithmo replace a human facilitator?",
    answer: "While Rithmo can handle many facilitation tasks, complex meetings still benefit from human facilitators who can handle nuance and relationship dynamics."
  },
  {
    question: "What industries is Rithmo best suited for?",
    answer: "Rithmo works well in any industry that relies on meetings, with particular benefits for knowledge work, consulting, and distributed teams."
  },
  {
    question: "Can educational institutions use Rithmo?",
    answer: "Yes, Rithmo can be used for educational settings including virtual classrooms and academic meetings."
  },
  {
    question: "Is Rithmo suitable for government meetings?",
    answer: "Rithmo can be used for government meetings and offers additional security and compliance features for public sector use."
  },
  {
    question: "What is the environmental impact of Rithmo?",
    answer: "By making meetings more efficient, Rithmo helps reduce the carbon footprint of business travel and long, unproductive meetings."
  },
  {
    question: "How does Rithmo support diversity and inclusion?",
    answer: "Rithmo promotes equitable participation and can help identify and address unconscious biases in meeting dynamics."
  },
  {
    question: "Can Rithmo help with language barriers?",
    answer: "While Rithmo doesn't provide translation, it can help ensure equitable participation regardless of language proficiency."
  },
  {
    question: "What accessibility features does Rithmo have?",
    answer: "Rithmo is designed with accessibility in mind, including screen reader support, keyboard navigation, and high contrast options."
  },
  {
    question: "How do I report a bug in Rithmo?",
    answer: "Use the support form to report bugs, or contact our development team directly for critical issues."
  },
  {
    question: "What is your response time for support?",
    answer: "We aim to respond to all support inquiries within 24 hours, with faster response times for critical issues."
  },
  {
    question: "Can I schedule a demo of Rithmo?",
    answer: "Demo requests are welcome through the support form. We'll schedule a personalized demonstration of Rithmo's capabilities."
  },
  {
    question: "Is there a Rithmo community or forum?",
    answer: "We're building a community forum for users to share best practices, tips, and feedback about Rithmo."
  },
  {
    question: "How can I stay updated on Rithmo developments?",
    answer: "Subscribe to our newsletter or follow us on social media for updates on new features and improvements."
  },
  {
    question: "What is the Rithmo roadmap?",
    answer: "Our roadmap includes expanded platform support, advanced AI features, mobile apps, and deeper integrations with business tools."
  },
  {
    question: "Can I beta test new Rithmo features?",
    answer: "Beta users can opt into feature previews to test new capabilities and provide feedback before general release."
  },
  {
    question: "How does Rithmo handle data portability?",
    answer: "You can export all your data in standard formats, ensuring you can move to other platforms if needed."
  },
  {
    question: "What is Rithmo's uptime guarantee?",
    answer: "We strive for 99.9% uptime and provide status updates during any service interruptions."
  },
  {
    question: "How does Rithmo handle service outages?",
    answer: "During outages, meetings continue normally, and Rithmo will automatically resume monitoring when service is restored."
  }
];
